import DashboardRouter from "./Dashboard.router";

export default DashboardRouter;
